import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn } from "@angular/forms";
import { IDeviceType } from "src/app/shared/models/IDevice-type";

export class DeviceTypeValidator {
    static ValidateDeviceTypeName(deviceTypes: IDeviceType[]): ValidatorFn {

        return (control: AbstractControl): { [key: string]: boolean } | null => {

            let controlValue = control.value as string;
            if (!controlValue || controlValue.trim() == '') {
                return null;
            }
            let controlId = (<UntypedFormGroup>control.parent).get('id')?.value as string;
            let controldeviceTypeName = (<UntypedFormGroup>control.parent).get('deviceTypeName')?.value as string;
            let existingDeviceTypeName = deviceTypes.find(x => (x.name.toLowerCase().trim() == controldeviceTypeName.toLowerCase().trim()
                && (x.id.toString() != controlId)));

            return existingDeviceTypeName ? { errorDeviceTypeName: true } : null;
        };
    }
    static ValidateDeviceTypeCode(deviceTypes: IDeviceType[]): ValidatorFn {

        return (control: AbstractControl): { [key: string]: boolean } | null => {

            let controlValue = control.value as string;
            if (!controlValue || controlValue.trim() == '') {
                return null;
            }
            let controlId = (<UntypedFormGroup>control.parent).get('id')?.value as string;
            let controldeviceTypeCode = (<UntypedFormGroup>control.parent).get('deviceTypeCode')?.value as string;
            let existingDeviceTypeCode = deviceTypes.find(x => (x.code.toLowerCase().trim() == controldeviceTypeCode.toLowerCase().trim()
                && (x.id.toString() != controlId)));

            return existingDeviceTypeCode ? { errorDeviceTypeCode: true } : null;
        };
    }

    static ValidateDeviceTypeModel(modelsRegex: string[]): ValidatorFn {

        return (control: AbstractControl): { [key: string]: boolean } | null => {

            let controlValue = control.value as string;

            if (!controlValue || controlValue.trim() == '' || !control.parent || !control.parent.controls) {
                return null;
            }
            let deviceTypeModels = (control.parent.controls) as UntypedFormControl[];
            let existingDeviceTypeModel = deviceTypeModels.find(x => x.value.toLowerCase().trim() === controlValue.toLowerCase().trim()
                && x != control);
            let existingDeviceTypeModelRegex = "";
            if (!existingDeviceTypeModel) {
                existingDeviceTypeModelRegex = modelsRegex.find(x => x.toLowerCase().trim() === controlValue.toLowerCase().trim());
            }
            return existingDeviceTypeModel || existingDeviceTypeModelRegex ? { errorDeviceTypeModel: true } : null;
        };
    }
    static ValidateDeviceTypeModelPattern(): ValidatorFn {

        return (control: AbstractControl): { [key: string]: boolean } | null => {
            let controlValue = control.value as string;
            if (!controlValue || controlValue.trim() == '') {
                return null;
            }
            let validRegexPattern = false;
            try {
                var pattern = new RegExp(controlValue); // your user input here
                if (pattern instanceof RegExp) {
                    validRegexPattern = true;
                }
            }
            catch (e) {

            }
            return !validRegexPattern ? { errorDeviceTypeModelPattern: true } : null;
        }
    }
}